var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-container"},[_c('div',{staticClass:"error-icon"}),_c('p',{staticClass:"error-text"},[_vm._v(" 作品已失效 ")])])}]

export { render, staticRenderFns }